<template>
  <div class="container justify-content-center">
    <div class="row">
      <div class="col-sm-9">
        <div class="justify-content-center" v-if="!isLoading" >
          <argon-alert v-if="showAlert" color="danger" :dismissible="true" @close-alert="closeAlertDanger">
            <strong>Alerta!</strong> Existen campos vacios que son obligatorios!
          </argon-alert>
          <argon-alert v-if="showSuccess" color="success" :dismissible="true" @close-alert="closeAlert">
            <strong>Completado!</strong>  Tú mensaje a sido enviado!
          </argon-alert>
          <div class="justify-content-center">
            <div class="row justify-content-center">
              <div class="col-10 div__title">
                <small>CONTACTO</small>
                <h3>Hola 👋, ¿Como podemos ayudar?</h3>
              </div>
              <div style="justify-content: end; align-items: end; align-items: end;">
                <div class="col-sm-3 col-12 ">
                <label for="example-text-input" class="form-control-label" >Categoria</label>
                <select class="form-select" aria-label="Default select example" @change="changeCategory($event.target.value)">
                  <option value="Comentario" :selected="comment.category === 'Comentario' ? true : false">
                    Comentario
                  </option>
                  <option value="Quejas" :selected="comment.category === 'Quejas' ? true : false">
                    Quejas
                  </option>
                </select>
              </div>
              </div>
              <div class="col-sm-4 col-12 ">
                <label for="example-text-input" class="form-control-label"
                  >Nombre</label
                >
                <argon-input
                  type="text"
                  v-model="comment.name"
                  id="0"
                  name="name"
                />
              </div>

              <div class="col-sm-4 col-12">
                <label for="example-text-input" class="form-control-label"
                  >Correo electrónico</label
                >
                <argon-input
                  type="email"
                  v-model="comment.email"
                  id="1"
                  name="email"
                />
                <div class="alert-container">
                  <argon-alert
                    v-if="showAlert"
                    color="danger"
                    :dismissible="true" 
                    @close-alert="closeAlertDanger">
                    Correo invalido.
                  </argon-alert>
                </div>
              </div>

              <div class="col-sm-4 col-12">
                <label for="example-text-input" class="form-control-label"
                  >Teléfono</label
                >
                <argon-input
                  type="text"
                  v-model="comment.phone"
                  id="2"
                  name="phone"
                />
              </div>

              <div class="col-sm-12">
                <label for="example-text-input" class="form-control-label"
                  >Mensaje</label
                >
                <argon-textarea
                  type="text"
                  v-model="comment.message"
                  id="3"
                  name="message"
                />
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-sm-4 justify-content-center">
                <argon-button
                  color="primary"
                  size="lg"
                  class="ms-auto"
                  @click.prevent="finalValidation"
                  :fullWidth="true"
                  >Enviar</argon-button
                >
              </div>
            </div>
            
          </div>
        </div>
      </div>
      
      <div class="col-sm-3 my-3">
        <div class="card align-content-center" style="width: 18rem;">
          <div class="card-body" style="background-color: #0154a0; border-radius: 20px;">
            <h6 style="color: white;">MEXICANA DE TÉCNICOS EN AUTOPISTAS S.A. DE C.V.
              LIBRAMIENTO ORIENTE KM 11 +200,
              SAN NICOLAS DE LOS JASSOS , SLP. <br>
              TELÉFONO: (444) 500 7200</h6>
            <h3 style="color: white;">Bolsa de trabajo</h3>
            <h6 style="color: white;">Tel: (444) 332 3306</h6>
            <h6 style="color: white; font-size: small;">nuevostalentos@valoran.com.mx</h6>
            <div v-if="manageables">
              <div class="div__social-media" v-for="manageable in manageables" :key="manageable.id">
                <h3 style="color: white;" class="">Síguenos</h3>
                <ul class="d-flex justify-content-start p-0">
                  <li>
                    <a target="_blank" :href="manageable.facebook">
                      <img src="/facebook.svg" width="40" alt="">
                    </a>
                  </li>
                  <li>
                    <a target="_blank" :href="manageable.twitter">
                      <img src="/twitter.svg" width="40" alt="">
                    </a>
                  </li>
                  <li>
                    <a target="_blank" :href="manageable.instagram">
                      <img src="/instagram.svg" width="40" alt="">
                    </a>
                  </li>
                  <!-- <li>
                    <router-link to="/meta/waze" target="_blank">
                      <img src="/waze 1.svg" width="40" alt="">
                    </router-link>
                  </li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>


<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonTextarea from "@/components/ArgonTextarea.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  name:"ContactUsSection",
  data() {
    return {
      manageables: undefined,
      showAlert: false,
      showSuccess: false,
      valid: {
        name: true,
        email: true,
        phone: true,
        message: true,
        category: true,
      },
      commentID: undefined,
      comment: {
        name:"",
        email:"",
        phone:"",
        message:"",
        category:"Comentario",
      },
    };
  },
  components: { ArgonInput, ArgonButton, ArgonTextarea, ArgonAlert },
  created() {
    this.createdManageables();
    this.isLoading = false;
  },
  methods: {
    createdManageables() {
        this.plain
        .get(`/manageables`)
        .then((response) => {
            if (response.data.length !== 0) this.manageables = response.data;
            else this.manageables = [];
            // console.log(this.manageables)
        })
        .catch((err) => {
            this.manageables = [];
            console.log(err);
        });
    },
    absoluteValidation() {
      this.showAlert = false;
      if(this.showSuccess === true){
        this.showSuccess = false
        this.valid = {
          name: true,
          email: true,
          phone: true,
          message: true,
          category: true,
        };
        this.comment = {
          name:"",
          email:"",
          phone:"",
          message:"",
          category:"",
        }
      }
      
    },
    createComment() {
      this.plain
      .post("/comments", this.comment)
      .then(() => {
        // console.log("COMENTARIO creado correctamente");
        // console.log(response.data);
        this.showSuccess = true;
        this.valid = {
          name: true,
          email: true,
          phone: true,
          message: true,
          category: true,
        };
        this.comment = {
          name:"",
          email:"",
          phone:"",
          message:"",
          category:"Comentario",
        }
      })
      .catch((error) => {
        console.log("Error al crear Comentario", error);
      });
    },
    changeCategory(category) {
      this.comment.category = category
      // console.log(this.comment)
    },
    validateEmail(email) {
      const emailRegex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
      return emailRegex.test(email);
    },
    validateInput(input, key) {
      if (key === "email") {
        this.valid[key] = this.validateEmail(input);
      } else {
        this.valid[key] = input.length > 0;
      }
      this.showAlert = false;
    },
    finalValidation() {
      this.valid.name = this.comment.name.length > 0;
      this.valid.email = this.validateEmail(this.comment.email);
      this.valid.phone = this.comment.phone.length > 0;
      this.valid.message = this.comment.message.length > 0;
      this.valid.category = this.comment.category.length > 0;

      if (Object.values(this.valid).every((val) => val === true)) {
        this.createComment();
        this.absoluteValidation();
      } else {
        this.showAlert = true;
        this.showSuccess = false;
      }
    },
    closeAlert(){
    this.showSuccess = false;
    },
    closeAlertDanger(){
      this.showAlert = false;
    },
  },
};
</script>

<style scoped lang="scss">

.div__social-media{
 text-align: left;
 margin-top: 15px;

 ul{
     list-style-type: none;
     li{
         float: left;
         a{
             display: block;
             padding-right: 10px;
             text-decoration: none;
         }
     }
  }
}
.alert-container {
  margin-top: 1px;
  width: 100%;
}
</style>
